<template>
  <div>
    <v-row align="center" class="px-12">

      <v-col cols="1" style="max-width: fit-content">
        <v-icon right @click="changePage">mdi-arrow-left</v-icon>
      </v-col>

      <v-col cols="10">
        <h4
          style="margin-left: 0px;font-size:28px; color:#777; font-weight:300; text-align:left; min-inline-size: max-content;"
        >{{editedQueue.name}}</h4>
      </v-col>

      <v-col cols="1">
        <v-btn icon color="admiraFontGray" class="py-0 my-0" style="margin-left:-55px;">
          <v-icon style="cursor: pointer; font-size:25px" @click="editQueue">mdi-pencil</v-icon>
        </v-btn>

        <!--Begin dialog delete-->

        <v-dialog width="500" v-model="deleteDialog">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              color="admiraFontGray"
              class="py-0 my-0"
              style="margin-left:-100px;"
            >
              <v-icon style="cursor: pointer; font-size:25px">mdi-delete</v-icon>
            </v-btn>
          </template>

          <v-card class="pl-5 pr-5">
            <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
            <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
              <p>
                ¿Estás seguro que quieres eliminar este elemento?
                <br />Esta acción no se puede deshacer
              </p>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-col cols="3">
                  <v-btn
                    style="border-color: #fff;"
                    @click="deleteDialog = false"
                    rounded
                    depressed
                    outlined
                    small
                    width="100"
                  >Cancelar</v-btn>
                </v-col>

                <v-col cols="3">
                  <v-btn
                    @click="deleteQueue({idQueue: editedQueue.idQueue})"
                    style="background: #679940;"
                    dark
                    rounded
                    depressed
                    outlined
                    small
                    width="100"
                  >Aceptar</v-btn>
                </v-col>
              </v-card-actions>
            </v-col>
          </v-card>
        </v-dialog>
      </v-col>

    </v-row>

    <v-divider />

    <v-row>

      <v-col style="border-right: 1px solid #eee;" cols="4">
        <v-row>
          <div v-if="editedQueue.type == 3">
            <p
              style="text-align: left; margin-left: 25px; font-size: 21px;color:#777; font-weight:300;    margin-bottom: 0px;"
              v-if="editedQueue.type == 3"
            >Fila Multipuesto con Tiquets</p>
            <br />
            <div style="display:flex;margin-left: 25px;">
              <div style="display:inline;">
                <v-icon style="font-size:55px;">mdi-ticket-confirmation</v-icon>
              </div>
              <div>
                <p
                  style="text-align: left; margin-left: 25px; font-size: 15px; color:#777; font-weight:300;"
                >Sistema de turnos para gestionar variospuestos con diversas cajas por puesto con impresión de tickets.</p>
              </div>
            </div>
          </div>
          <div v-if="editedQueue.type == 2">
            <p
              style="text-align: left; margin-left: 25px; font-size: 21px; color:#777; font-weight:300;    margin-bottom: 0px;"
            >Fila Única con Tiquets</p>
            <br />
            <div style="display:flex;margin-left: 25px;">
              <div>
                <v-icon style="font-size:55px">mdi-ticket-outline</v-icon>
              </div>
              <p
                style="text-align: left; margin-left: 25px; font-size: 15px; color:#777; font-weight:300;    margin-bottom: 0px;"
              >Sistema de fila única con impresión de tickets.</p>
            </div>
          </div>
          <div v-if="editedQueue.type == 1">
            <p
              style="text-align: left; margin-left: 25px; font-size: 21px; color:#777; font-weight:300;"
            >Fila Única</p>
            <br />
            <div style="display:flex;margin-left: 25px;">
              <div>
                <v-icon style="font-size:55px">mdi-human-male-male</v-icon>
              </div>
              <p
                style="text-align: left; margin-left: 25px; font-size: 15px; color:#777; font-weight:300;"
              >Sistema de fila individual sin tickets. Conforme los clientes alcanzan el frente, ellos son llamados para el siguiente mostrador disponible cuando el contador presiona un botón.</p>
            </div>
          </div>
        </v-row>
        <v-row>
          <br />
          <p
            style="text-align: left; margin-left: 25px; font-size: 21px;margin-top: 15px; color:#777; font-weight:300;"
          >Turnos</p>
        </v-row>
        <v-row style="" v-for="tiquets in arrTiquets" :key="tiquets.resources">
          <v-col
            v-if="tiquets.operative === 1"
          >
          <v-container  style="background-color: #eeee; border-radius: 15px;  margin-left: 35px; ">
           <p
              style=" color:#acacac; margin-bottom: 0px; font-size: 30px; font-weight: 300; "
              v-if="tiquets.ticketNow != null"
            >{{tiquets.ticketNow.ticket}}</p>
            <p
              style=" color:#acacac; margin-bottom: 0px; font-size: 30px; font-weight: 300; "
              v-if="tiquets.ticketNow == null"
            >--</p>
          </v-container>
 
          </v-col>
          <v-col v-if="tiquets.operative === 1">
            <p
              style="color:#acacac; margin-bottom: 0px; font-size: 22px; font-weight: 300;padding-top: 15px;"
              v-if="tiquets.resources != null"
            >{{tiquets.spaceName}}</p>
          </v-col>
        </v-row>
      </v-col>

      <!-- <v-divider vertical class="pa-0"></v-divider> -->

      <v-col  style="border-right: 1px solid #eee;" cols="8">
        <v-row>

          <v-col cols="10">
            <p
              style="text-align: left; margin-left: 25px; font-size: 21px; color:#777; font-weight:300;"
            >Stands</p>
          </v-col>

          <v-col cols="2">
            
            <v-btn
              icon
              color="admiraFontGray"
              style="float-right:margin-right:100px;"
            >
              <v-icon style="cursor: pointer; font-size:28px" @click="addStand">mdi-plus-circle</v-icon>
            </v-btn>

            <v-dialog width="500" v-model="deleteDialog" v-if="selected.length > 0">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  color="admiraFontGray"
                  class="py-0 my-0"
                >
                  <v-icon style="cursor: pointer; font-size:25px">mdi-delete</v-icon>
                </v-btn>
              </template>

              <v-card class="pl-5 pr-5">
                <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
                <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
                  <p>
                    ¿Estás seguro que quieres eliminar este elemento?
                    <br />Esta acción no se puede deshacer
                  </p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-col cols="6">
                      <v-btn
                        style="border-color: #fff;"
                        @click="deleteDialog = false"
                        rounded
                        depressed
                        outlined
                        small
                        width="100"
                      >Cancelar</v-btn>
                    </v-col>

                    <v-col cols="6">
                      <v-btn
                        @click="quitStandMulti(selected)"
                        style="background: #679940;"
                        dark
                        rounded
                        depressed
                        outlined
                        small
                        width="100"
                      >Aceptar</v-btn>
                    </v-col>
                  </v-card-actions>
                </v-col>
              </v-card>
            </v-dialog>


          </v-col>
          
        </v-row>
        <v-data-table
                v-model="selected"
                @click:row="viewResource"
                show-select
                :items="arrStands"
                :headers="headers"
                :item-class="rowClass"
                item-key="idResource"
                class="elevation-0"
                style="color: #777;"
                sortBy="idResource"
                update: sort-asc
              >
                <template v-slot:item.icon="{ item }">
                  <v-icon :color="(item.operative === 1) ? 'admiraGreen' : 'gray'" >mdi-store</v-icon>
                </template>

              <template v-slot:item.actions="{ item }">
                  <v-menu offset-y transition="slide-y-transition" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon small>
                        <v-icon dark>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <!-- <v-list-item @click="infoStand(item)">
                        <v-list-item-title style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 21px;">mdi-information-variant</v-icon> Detalles</v-list-item-title>
                      </v-list-item> -->
                      <v-list-item v-if="item.operative === 1" @click="changeResource(item.idResource)">
                        <v-list-item-title class="d-flex justify-start align-center" style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 19px;">mdi-lock-outline</v-icon><span class="ml-2">Inhabilitar</span></v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.operative === 1" @click="viewResource(item)" >
                        <v-list-item-title class="d-flex justify-start align-center" style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 19px;">mdi-play-circle</v-icon><span class="ml-2">Turnos</span></v-list-item-title>
                      </v-list-item>
                       <v-list-item v-if="item.operative !== 1" @click="changeResource(item.idResource)">
                        <v-list-item-title class="d-flex justify-start align-center" style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 19px;">mdi-lock-open-outline</v-icon><span class="ml-2">Habilitar</span></v-list-item-title>
                      </v-list-item>
                      <v-list-item >
                        <v-dialog width="500" v-model="deleteDialog">
                          <template v-slot:activator="{ on }">
                            <v-list-item-title v-on="on" class="d-flex justify-start align-center" style="cursor:pointer; font-size:12px; color:#9e9e9e"><v-icon style="font-size: 19px;">mdi-close-circle-outline</v-icon><span class="ml-2">Quitar</span></v-list-item-title>
                        <!-- <v-btn
                          v-on="on"
                          
                        > <v-icon style="cursor: pointer; color:#9e9e9e; font-size:12px">Quitar</v-icon>
                        </v-btn> -->
                      </template>
                        <v-card class="pl-5 pr-5">
                          <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
                          <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
                            <p>¿Estás seguro que quieres eliminar este elemento?<br>Esta acción no se puede deshacer</p>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-col cols="6">
                                <v-btn
                                  style="border-color: #fff;"
                                  @click="deleteDialog = false"
                                  rounded
                                  depressed
                                  outlined
                                  small
                                  width="100"
                                >Cancelar</v-btn>
                              </v-col>

                              <v-col cols="6">
                                <v-btn
                                  @click="quitStand(item)"
                                  style="background: #679940;"
                                  dark
                                  rounded
                                  depressed
                                  outlined
                                  small
                                  width="100"
                                >Aceptar</v-btn>
                              </v-col>
                            </v-card-actions>
                          </v-col>
                        </v-card>
                      </v-dialog> 
                      </v-list-item>
                    </v-list>
                  </v-menu>     
                </template>
        </v-data-table>
      </v-col>

      <!-- <v-divider vertical class="pa-0"></v-divider> -->

      <!-- <v-col cols="3" style="padding: 0px;">
        <div v-if="editedQueue.type == 3">

          <v-tabs
            class="tabs"
            centered
            grow
            height="45px"
            v-model="activeTab"
          >
            <v-tab>Pantalla</v-tab>
            <v-tab>Kiosko</v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <v-tab-item v-for="tab in tabs" :key="tab.id"> -->
              <!--Begin tab Descripción-->
              <!-- <v-container v-if="tab.id == 1" class fluid style="padding-top: 0px; padding-bottom: 0px;">
               <v-row style="padding-top: 0px; padding-bottom: 0px; background-color:#f5f5f5;">

                  <v-col style="padding: 0px;">
                    <p
                      style="margin-bottom: 0px; margin-top: 16px;text-align: left; margin-left: 25px; font-size: 19px; color:#777; font-weight:300;margin-right: 70px;"
                    >Contenido</p>
                  </v-col >

                  <v-col style="padding: 0px;">
                    <v-switch small label="Online"></v-switch>
                  </v-col>
                 
                </v-row>
                 <v-row style=" background-color:#f5f5f5">
                   <v-col v-bind:style="{backgroundColor: color}" style="padding-top: 0px; background-color:#f5b70e; margin-left:35px; margin-right:45px; margin-bottom:25px">
                     <p id="hour" style="float:right;">10:45 AM</p>
                      <v-col v-bind:style="{backgroundColor: color1}" style=" background-color:#f6c231; margin-top:35px;  border: 2px solid white;border-radius: 25px;">
                        <p v-bind:style="{color: color2}" >HTML</p>
                      </v-col>
                   </v-col>
                  </v-row>

                <v-divider />

                <v-row style="margin:15px; padding-right: 50px; margin-top: 15px;">
                  <v-text-field
                    @input="hideAlertNameCont"
                    label="Nombre Contenido"
                    v-model="objQueueCont.name"
                    dense
                    required
                    maxlength="40"
                    :hint="objQueueCont.name ? `${objQueueCont.name.length}/40` : ''"
                  ></v-text-field>
                  <v-alert
                    v-if="showAlertName"
                    dense
                    elevation="0"
                    class="text-left"
                    style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                  >Necesita un nombre el Contenido</v-alert>
                </v-row>

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color}}</p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color1"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color1"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color1}}</p>
                  </v-col>
                </v-row>
                

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color2"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color2"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color2}}</p>
                  </v-col>
                </v-row>

               <v-row style="margin-left:5px; padding-right:50px;">
                  <v-col >
                    <v-text-field
                      @input="hideAlertWidthCont"
                      label="Width"
                      v-model="objQueueCont.width"
                      dense
                      required
                      suffix="px"
                    ></v-text-field>
                    <v-alert
                      v-if="showAlertWidth"
                      dense
                      elevation="0"
                      class="text-left"
                      style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                    >Necesita un ancho el contenido</v-alert>
                  </v-col>

                  <v-col style=" margin-left:5px; ">
                    <v-text-field
                      @input="hideAlertHeightCont"
                      label="Height"
                      v-model="objQueueCont.height"
                      dense
                      required
                      suffix="px"
                    ></v-text-field>
                    <v-alert
                      v-if="showAlertHeight"
                      dense
                      elevation="0"
                      class="text-left"
                      style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                    >Necesita un alto el contenido</v-alert>
                  </v-col>
                </v-row>
                
                <v-row style="    margin-left: 15px; padding-right: 50px;">
                  <v-file-input chips truncate-length="25" label="Añade tu logo" style="padding-top: 0px;"></v-file-input>
                </v-row>

                <v-row style="    margin-left: 15px; padding-right: 50px;">
                  <v-checkbox style="margin-top: 5px;" @click="setClock" v-model="checkbox" :label="`Clock`"></v-checkbox>
                </v-row>
         
              </v-container> -->

              <!--Begin tab kiosko-->
              <!-- <v-container v-if="tab.id == 2" style="padding-top: 0px; padding-bottom: 0px;">
              <v-row style="padding-top: 0px; padding-bottom: 0px; background-color:#f5f5f5;">

                  <v-col style="padding: 0px;">
                    <p
                      style="margin-bottom: 0px; margin-top: 16px;text-align: left; margin-left: 25px; font-size: 19px; color:#777; font-weight:300;margin-right: 70px;"
                    >Contenido</p>
                  </v-col >

                  <v-col style="padding: 0px;">
                    <v-switch small label="Online"></v-switch>
                  </v-col>
                 
                </v-row>
                 <v-row style=" background-color:#f5f5f5">
                   <v-col v-bind:style="{backgroundColor: color3}" style="padding-top: 0px; background-color:#f5b70e; margin-left:35px; margin-right:45px; margin-bottom:25px">
                     <p id="hour" style="float:right;">10:45 AM</p>
                      <v-col v-bind:style="{backgroundColor: color4}" style=" background-color:#f6c231; margin-top:35px;  border: 2px solid white;border-radius: 25px;">
                        <p v-bind:style="{color: color5}" >HTML</p>
                      </v-col>
                   </v-col>
                  </v-row>

                <v-divider />

                <v-row style="margin:15px; padding-right: 50px; margin-top: 15px;">
                  <v-text-field
                    @input="hideAlertNameCont"
                    label="Nombre Contenido"
                    v-model="objQueueCont.name"
                    dense
                    required
                    maxlength="40"
                    :hint="objQueueCont.name ? `${objQueueCont.name.length}/40` : ''"
                  ></v-text-field>
                  <v-alert
                    v-if="showAlertName"
                    dense
                    elevation="0"
                    class="text-left"
                    style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                  >Necesita un nombre el Contenido</v-alert>
                </v-row>

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color3"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color3"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color3}}</p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color4"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color4"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color4}}</p>
                  </v-col>
                </v-row>
                

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color5"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color5"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color5}}</p>
                  </v-col>
                </v-row>

               <v-row style="margin-left:5px; padding-right:50px;">
                  <v-col >
                    <v-text-field
                      @input="hideAlertWidthCont"
                      label="Width"
                      v-model="objQueueCont.width"
                      dense
                      required
                      suffix="px"
                    ></v-text-field>
                    <v-alert
                      v-if="showAlertWidth"
                      dense
                      elevation="0"
                      class="text-left"
                      style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                    >Necesita un ancho el contenido</v-alert>
                  </v-col>

                  <v-col style=" margin-left:5px; ">
                    <v-text-field
                      @input="hideAlertHeightCont"
                      label="Height"
                      v-model="objQueueCont.height"
                      dense
                      required
                      suffix="px"
                    ></v-text-field>
                    <v-alert
                      v-if="showAlertHeight"
                      dense
                      elevation="0"
                      class="text-left"
                      style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                    >Necesita un alto el contenido</v-alert>
                  </v-col>
                </v-row>
                
                <v-row style="    margin-left: 15px; padding-right: 50px;">
                  <v-file-input chips truncate-length="25" label="Añade tu logo" style="padding-top: 0px;"></v-file-input>
                </v-row>

                <v-row style="    margin-left: 15px; padding-right: 50px;">
                  <v-checkbox style="margin-top: 5px;" @click="setClock" v-model="checkbox" :label="`Clock`"></v-checkbox>
                </v-row>
              </v-container>

            </v-tab-item>
          </v-tabs-items>

        </div>

        <div v-if="editedQueue.type == 1 || editedQueue.type == 2" style="display:flex;">
          <v-container class fluid>
           <v-row style="padding-top: 0px; padding-bottom: 0px; background-color:#f5f5f5;">

                  <v-col style="padding: 0px;">
                    <p
                      style="margin-bottom: 0px; margin-top: 16px;text-align: left; margin-left: 25px; font-size: 19px; color:#777; font-weight:300;margin-right: 70px;"
                    >Contenido</p>
                  </v-col >

                  <v-col style="padding: 0px;">
                    <v-switch small label="Online"></v-switch>
                  </v-col>
                 
                </v-row>
                 <v-row style=" background-color:#f5f5f5">
                   <v-col v-bind:style="{backgroundColor: color6}" style="padding-top: 0px; background-color:#f5b70e; margin-left:35px; margin-right:45px; margin-bottom:25px">
                     <p id="hour" style="float:right;">10:45 AM</p>
                      <v-col v-bind:style="{backgroundColor: color7}" style=" background-color:#f6c231; margin-top:35px;  border: 2px solid white;border-radius: 25px;">
                        <p v-bind:style="{color: color8}" >HTML</p>
                      </v-col>
                   </v-col>
                  </v-row>

                <v-divider />

                <v-row style="margin:15px; padding-right: 50px; margin-top: 15px;">
                  <v-text-field
                    @input="hideAlertNameCont"
                    label="Nombre Contenido"
                    v-model="objQueueCont.name"
                    dense
                    required
                    maxlength="40"
                    :hint="objQueueCont.name ? `${objQueueCont.name.length}/40` : ''"
                  ></v-text-field>
                  <v-alert
                    v-if="showAlertName"
                    dense
                    elevation="0"
                    class="text-left"
                    style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                  >Necesita un nombre el Contenido</v-alert>
                </v-row>

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color6"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color6"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color6}}</p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color7"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color7"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color7}}</p>
                  </v-col>
                </v-row>
                

                <v-row>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <div style="text-align:left; margin-left: 15px;">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :color="color8"
                            dark
                            v-on="on"
                          >
                          </v-btn>
                        </template>
                        <v-color-picker
                        value="#7417BE"
                        v-model="color8"
                        hide-canvas 
                        hide-inputs 
                        show-swatches
                        class="mx-auto"
                      ></v-color-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col style="padding-bottom: 0px; padding-top: 0px;">
                    <p style="float: left;">{{color8}}</p>
                  </v-col>
                </v-row>

               <v-row style="margin-left:5px; padding-right:50px;">
                  <v-col >
                    <v-text-field
                      @input="hideAlertWidthCont"
                      label="Width"
                      v-model="objQueueCont.width"
                      dense
                      required
                      suffix="px"
                    ></v-text-field>
                    <v-alert
                      v-if="showAlertWidth"
                      dense
                      elevation="0"
                      class="text-left"
                      style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                    >Necesita un ancho el contenido</v-alert>
                  </v-col>

                  <v-col style=" margin-left:5px; ">
                    <v-text-field
                      @input="hideAlertHeightCont"
                      label="Height"
                      v-model="objQueueCont.height"
                      dense
                      required
                      suffix="px"
                    ></v-text-field>
                    <v-alert
                      v-if="showAlertHeight"
                      dense
                      elevation="0"
                      class="text-left"
                      style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                    >Necesita un alto el contenido</v-alert>
                  </v-col>
                </v-row>
                
                <v-row style="    margin-left: 15px; padding-right: 50px;">
                  <v-file-input chips truncate-length="25" label="Añade tu logo" style="padding-top: 0px;"></v-file-input>
                </v-row>
                <v-row>
                  <v-btn
                  @click="sendHtmlSpace(objQueueCont)"
                  color="#679940"
                  dark
                  rounded
                  depressed
                  small
                  min-width="100"
                  >Añadir</v-btn>
                </v-row>
                <v-row style="    margin-left: 15px; padding-right: 50px;">
                  <v-checkbox style="margin-top: 5px;" @click="setClock" v-model="checkbox" :label="`Clock`"></v-checkbox>
                </v-row>
          </v-container>
        </div>
      </v-col> -->

    </v-row>

    <!--End dialog delete-->
    <v-navigation-drawer
      hide-overlay
      :disable-route-watcher="true"
      :value="showRightMenu"
      absolute
      :clipped="$vuetify.breakpoint.smAndUp"
      width="419"
      style="height: calc(100vh - 50px);z-index:100"
      class="elevation-4"
      right
      stateless
    >
      <RightMenuEditQueue v-if="RightMenuEditQueue" />
      <RightMenuAddNewStand v-if="RightMenuAddNewStand" />
      <RightMenuStandDetail v-if="RightMenuStandDetail" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import router from "vue-router";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
import RightMenuAddNewStand from "@/components/RightMenuAddNewStand.vue";
import RightMenuStandDetail from "@/components/RightMenuStandDetail.vue";

export default {
  name: "queues",
  components: {
    RightMenuEditQueue,
    RightMenuAddNewStand,
    RightMenuStandDetail
  },
  data: () => ({
        color: '#f5b70e',
        color1: '#f6c231',
        color2: '#FFFFFFFF',
        color3: '#f5b70e',
        color4: '#f6c231',
        color5: '#FFFFFFFF',
        color6: '#f5b70e',
        color7: '#f6c231',
        color8: '#FFFFFFFF',

        // color2: 'black',
        // color3: 'blue',

    selected: [],
    tiquets: this.TicketsBySpace,
    checkbox: true,
    showAlertName: false,
    showAlertWidth: false,
    showAlertHeight: false,
    tabs: [
      { id: 1, name: "DESCRIPCIÓN", route: "" },
      { id: 2, name: "CALENDARIO", route: "" }
    ],
    activeTab: null,
    deleteDialog: false
  }),
  computed: {
    arrStands() {
      let stands = this.allResouces;
      let arrayResources = this.editedQueue.resources;
      let arrayResourcesNumber = [];
      
      arrayResources.forEach(element => {
        let resourceId = parseInt(element)
        arrayResourcesNumber.push(resourceId)
      });
      
      if (arrayResourcesNumber != undefined) {
        stands = stands.filter(
          stand => arrayResourcesNumber.indexOf(stand.idResource) !== -1
        );

        return stands;
      } else {
        console.log("entro aqui");
        stands = [];
        return stands;
      }
    },
    arrTiquets() {
      let tiquets = this.TicketsBySpace;
      const allResouces = this.allResouces;
      let tiquetsFinal = [];
      let idQueue = this.editedQueue.idQueue;

      if (idQueue != undefined) {
        for (let i = 0; i < tiquets.length; i++) {
          if (tiquets[i].queue == idQueue) {
            tiquets[i].operative = allResouces.find(resource => resource.idResource === +tiquets[i].resources).operative || 0
            tiquetsFinal.push(tiquets[i]);
          }
        }
        return tiquetsFinal;
      } else {
        tiquetsFinal = [];
        return tiquetsFinal;
      }
    },
    ...mapState("queues", [
      "TicketsBySpace",
      "objQueueCont",
      "editedQueue",
      "allResouces",
      "showRightMenu",
      "RightMenuEditQueue",
      "RightMenuAddNewStand",
      "RightMenuStandDetail",
      "asociatedSpaces"
    ]),
    headers() {
      return [
        { text: "", value: "icon" },
        { text: "Nombre", value: "name", align: "start" },
        { text: "Sitio", value: "spaceName" },
        { text: "", value: "actions" }
      ];
    }
  },
  methods: {
    ...mapActions("queues", [
      "getTicketBySpace",
      "getTicketStore",
      "editQueueStore",
      "deleteOneQueueStore",
      "showRightMenuProposalStore",
      "rightMenuTrueNewDeviceTableStore",
      "rightMenuTrueNewDeviceTableStore2",
      "rightMenuTrueNewDeviceTableStore3",
      "rightMenuTrueNewDeviceTableStore4",
      "getTicketBySpaceStore",
      "editedQueueStore",
      "sendHtmlSpaceStore",
      "changeOperative"
    ]),
    ...mapMutations("queues", [
      "spaceActions",
      "openRightMenuMutation",
      "closeRightMenuMutation"
    ]),
    rowClass(resource){
     return (resource.operative === 1) ? "allowed" : "not-allowed"
    },
    changeResource(idResource){
      this.changeOperative(idResource);
    },
    hideAlertNameCont() {
      if (this.objQueueCont.name != "") {
        this.showAlertName = false;
      }
    },
    hideAlertWidthCont() {
      if (this.objQueueCont.width != "") {
        this.showAlertWidth = false;
      }
    },
    hideAlertHeightCont() {
      if (this.objQueueCont.height != "") {
        this.showAlertHeight = false;
      }
    },

    changePage() {
        this.$router.push({
            name: "Queues",
        });
        this.closeRightMenuMutation();
    },
    editQueue(data) {
      console.log("Editar cola");

      this.openRightMenuMutation();
      //this.rightMenuTrueNewStore()
      this.rightMenuTrueNewDeviceTableStore2(this.editedQueue);
      //this.rightMenuTrueStore()
    },
    deleteQueue(data) {
      console.log(data);

      this.deleteOneQueueStore(data);
      this.$router.go(-1);
      this.closeRightMenuMutation();
    },
    addStand() {
      console.log("añadir stand");
      console.log(this.editedQueue);
            console.log(this.allResouces);

      
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore3();
    },
    quitStand(data) {
      const index = this.editedQueue.resources.indexOf(data.idResource);
      if (index > -1) {
        this.editedQueue.resources.splice(index, 1);
      }
      this.editedQueueStore(this.editedQueue);
      this.deleteDialog = false;
      this.selected = [];
    },
    quitStandMulti(data) {
      console.log("entro multi");

      data.forEach(element => {
        const index2 = this.editedQueue.resources.indexOf(element.idResource);
        if (index2 > -1) {
          this.editedQueue.resources.splice(index2, 1);
        }
      });
      
      this.editedQueueStore(this.editedQueue);
      this.deleteDialog = false;
      this.selected = [];
    },
    infoStand(data) {
      (this.RightMenuEditQueue = false),
        (this.RightMenuAddNewStand = false),
        console.log("info del stand");
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore4();
    },

    viewResource(data) {
      if (data.operative === 1){
        this.spaceActions(data);
        this.$router.push({
          name: "QueueStandTurn",
          params: { idSpace: data }
        });
        this.getTicketStore(data.idResource);
      }
    },
    setClock(){
      
      let element = document.getElementById("hour");
      
      if(this.checkbox == false){
        element.style.display='none';     
      }else{
        element.style.display='';     
      }

    },
    sendHtmlSpace(cont){
      cont.dems = this.color6
      cont.sed = this.color7
      cont.qwer = this.color8
      console.log(cont);
      // this.sendHtmlSpaceStore();
    }

  },
  async created() {
    this.getTicketBySpace(this.editedQueue.space);
  }
};
</script>
<style lang="css">
  .allowed {
    cursor: pointer;
  }
  .not-allowed {
  cursor: not-allowed;
  }
</style>
<style scoped>
h5 {
  font-size: 12px;
  font-weight: 300;
  text-align: initial;
}

h3 {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #aeaeae;
}
>>> .v-data-table__wrapper {
  height: calc(100vh - 256px);
  overflow: auto;
}

</style>


// WEBPACK FOOTER //
// src/views/desktop/QueueDetails.vue